import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';

type LanguageState = 'active' | 'inactive' | 'unused';

export const LANGUAGE_OPERATIONS = {
	NO_OP: 'NO_OP',
	ADD_LANGUAGE: 'ADD_LANGUAGE',
	REMOVE_LANGUAGE: 'REMOVE_LANGUAGE',
	SET_AVAILABLE: 'SET_AVAILABLE',
	SET_UNAVAILABLE: 'SET_UNAVAILABLE',
	SET_DEFAULT_LANGUAGE: 'SET_DEFAULT_LANGUAGE',
} as const;

type LanguageOperationsEnum = keyof typeof LANGUAGE_OPERATIONS;

export type Language = {
	key: string;
	label: string;
	state: LanguageState;
};

export type ProjectDefaultLanguage = {
	key: string;
	label: string;
};

type LanguagesResponse = {
	projectDefaultLanguage: ProjectDefaultLanguage;
	shouldAskUserToConfirmLanguages: boolean;
	languages: Language[];
};

type EventAttributes = {
	languageKey?: string;
	languageKeys?: string[];
};

export type State = {
	loading: boolean;
	error: Error | undefined;
	data: LanguagesResponse;
	currentOperation: {
		type: LanguageOperationsEnum;
		updatedLanguages: Language[];
		addedLanguages: Language[];
		languageLabel: string;
		analytics:
			| undefined
			| {
					event: UIAnalyticsEvent;
					attributes: EventAttributes;
			  };
	};
};

export type LanguagesUpdatePayload = {
	languageTag: string;
	enabled: boolean;
};

export type UpdateLanguagesParams = {
	projectId: number;
	updatedLanguages: Language[];
	addedLanguages: Language[];
	defaultLanguageKey: string;
	analytics:
		| undefined
		| {
				event: UIAnalyticsEvent;
				attributes: EventAttributes;
		  };
};
